<div class="sistema-container-row">
    <div class="center">
        <div class="upload-sistema" [class.disabled]="isCloneMode" [attr.aria-disabled]="isCloneMode" (click)="openModal()" >
            <label for="file-upload" class="file-upload-label">
            <img src='../../../../assets/icon/Upload.svg' alt="" class="upload-icon" />{{ 'Upload File'|translate }}
            </label>
        </div>
    </div>
</div>
<app-grid [ngClass]="isSistemaGridDisplayed ? 'show' : 'hide' " class="margin-left-112"
    [columns]="sistemaGridColumnDefs" [data]="this.sistemaImagesList" [gridConfigItems]="sistemaGridConfigItems"
    (onCellClick)="fnOnSistemaGridCellClick($event)" [showKebabIcon]="false" [searchDisabled]="isCloneMode">
</app-grid>